/**
 * @voltxampere/web — UndoStack singleton (Sprint 14.0.1, D6 closure)
 *
 * Sprint 13 introduced the `UndoStack` (ADR-0017) with the
 * canvas as its sole owner — every `<vxa-canvas>` instance
 * created its own private stack. That worked for the canvas
 * tools because they all share the host element, but it left
 * `<vxa-inspector>` (Sprint 14) without an undo path: the
 * inspector lives outside the canvas's shadow root, never sees
 * the private field, and Sprint 14 fell back to applying
 * commands directly on `currentCircuit` (D6 sapması).
 *
 * Sprint 14.0.1 lifts the stack to module scope so every consumer
 * (canvas tools, inspector edits, future toolbar) shares the
 * same history — one Cmd+Z reverts the most recent action no
 * matter who emitted it.
 *
 * Sprint 19 persistence will swap the in-memory stack for a
 * persisted-on-disk variant; the singleton boundary stays so
 * consumers do not need to rewire.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */

import { UndoStack } from "@voltxampere/ui/canvas";

/**
 * The single live UndoStack for the studio shell. Everyone
 * that mutates `currentCircuit` should funnel through
 * `undoStack.execute(cmd, circuit)` so Cmd+Z / Cmd+Shift+Z
 * remain coherent.
 */
export const undoStack = new UndoStack();
